import { render } from "./Departemen.vue?vue&type=template&id=e4e4122a"
import script from "./Departemen.vue?vue&type=script&lang=js"
export * from "./Departemen.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__